import axios from '../plugins/axios.js';

export default {
    async index() {
        const response = await axios.get('v1/imports');
        return response.data.data;
    },

    async show(importId) {
        const response = await axios.get(`v1/imports/${importId}`);
        return response.data.data;
    },

    async update(id, payload) {
        const response = await axios.put(`v1/imports/${id}`, payload);
        return response.data.data;
    },

    async delete(importId) {
        const response = await axios.delete(`v1/imports/${importId}`);
        return response.data.data;
    },

    async store(payload) {
        const response = await axios.post('v1/imports', payload);
        return response.data.data;
    },

    async process(importId, payload) {
        const response = await axios.put(`v1/imports/${importId}/process`, payload);
        return response.data.data;
    },
};
